import React from 'react';
import MortgageForm from "../../../../../components/data-capture/MortgageForm";

function ApplicationForm({section, inExtWindow=true}) {

    return (
        <MortgageForm inExtWindow={inExtWindow} questions={[
            {
                label: "First Name",
                name: "firstName",
                answer: {
                    type: "text",
                },
                target: `applicant${section.applicant}.firstName`,
            },
            {
                label: "Surname",
                name: "surname",
                answer: {
                    type: "text",
                },
                target: `applicant${section.applicant}.surname`,
            }
        ]}/>
    );
}

export default ApplicationForm;